import { datadogRum } from '@datadog/browser-rum';
import { User } from 'web-shared/types/User.types';
import { SharedReduxState } from '../reducers/types';
import { UserCompany } from '../api/types/UserCompany.types';
import { getOwnPortal } from '../utils/user-helper';
import { SYSTEM_COMPANY_TYPE } from '../types/Company.types';
import { UserImpersonation } from './user-impersonation';

declare const pendo: any;

interface Props {
  user: User;
  company: UserCompany;
  userPreferences: SharedReduxState['userPreferences'];
}

export const setUser = ({ user, company, userPreferences }: Props) => {
  if (user && company && process.env.PENDO_KEY) {
    const originalUserId = UserImpersonation.getImpersonationData()?.originalUserId;
    const portal = company.workspaces.length > 0 ? (
      getOwnPortal(company.workspaces) || company.workspaces[0].portals[0]
    ) : null;
    try {
      pendo.initialize({
        visitor: {
          id: originalUserId || user.id,
          customer_id: user.id,
          email: user.email,
          name: `${user.first_name} ${user.last_name}`,
          role: company.role_name,
          company_name: company.legal_name,
          company_id: company.id,
          language: userPreferences.locale,
          timezone: userPreferences.timezone,
          impersonation: !!originalUserId,
          oh_user: !!originalUserId || company.type === SYSTEM_COMPANY_TYPE.OH
        },
        account: {
          id: portal?.id,
          name: portal?.name,
        }
      });
    } catch (error) {
      if (process.env.DATADOG_APP_ID) {
        datadogRum.addError(error);
      }
    }
  }
};